var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"loader is-loading"}),(_vm.geolocating)?_c('div',{staticClass:"geolocator"},[_c('i',{staticClass:"far fa-compass"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }